import { useTranslation } from 'react-i18next';
import { useHistoryTexts, useUndoActions, useUndoSnapshot } from '../hooks/useUndo';
import { RedoIcon, UndoIcon } from '../ui/icons';
import styles from './TopBar.module.css';

/** Undo and redo icon buttons; the tooltip names the operation they would reverse or restore. */
export function UndoButtons() {
  const { t } = useTranslation();
  const { state } = useUndoSnapshot();
  const { undo, redo } = useUndoActions();
  const texts = useHistoryTexts(state.history);
  // The history lists the redo steps first (the next one to redo is the last of them), then the undo steps.
  const undoIndex = state.history.findIndex((item) => !item.undone);
  const redoIndex = state.history.findLastIndex((item) => item.undone);
  const undoLabel =
    state.undoLabel === null
      ? t('undo.nothingToUndo')
      : t('undo.undoWith', { label: texts[undoIndex] ?? t(`command.${state.undoLabel}`) });
  const redoLabel =
    state.redoLabel === null
      ? t('undo.nothingToRedo')
      : t('undo.redoWith', { label: texts[redoIndex] ?? t(`command.${state.redoLabel}`) });
  return (
    <div className={styles.group}>
      <button
        type="button"
        className={styles.iconButton}
        disabled={!state.canUndo}
        title={undoLabel}
        aria-label={t('undo.undo')}
        data-testid="undo-button"
        onClick={() => void undo()}
      >
        <UndoIcon />
      </button>
      <button
        type="button"
        className={styles.iconButton}
        disabled={!state.canRedo}
        title={redoLabel}
        aria-label={t('undo.redo')}
        data-testid="redo-button"
        onClick={() => void redo()}
      >
        <RedoIcon />
      </button>
    </div>
  );
}
